import script from "./MaterialCustomDropDown.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialCustomDropDown.vue?vue&type=script&setup=true&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./MaterialCustomDropDown.vue?vue&type=style&index=1&id=8f37a038&lang=stylus"

const __exports__ = script;

export default __exports__